// Cempasúchil (marigold) — used as decorative accent + falling petals.
export function Marigold({ size = 24, color = "#F2A33A" }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      <g fill={color}>
        {[0, 45, 90, 135, 180, 225, 270, 315].map((deg) => (
          <ellipse key={deg} cx="16" cy="6" rx="3.2" ry="6" transform={`rotate(${deg} 16 16)`} />
        ))}
      </g>
      <circle cx="16" cy="16" r="3.5" fill="#C84B1A" />
    </svg>
  );
}

export function PetalRain({ count = 14 }: { count?: number }) {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-[60]">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="absolute animate-petalFall"
          style={{
            left: `${(i * 7 + Math.random() * 6) % 100}%`,
            animationDelay: `${(i * 0.6) % 6}s`,
            animationDuration: `${7 + (i % 4)}s`,
          }}
        >
          <Marigold size={16 + (i % 3) * 6} />
        </div>
      ))}
    </div>
  );
}
